import type { ColumnDefProps } from '../types'

export const calculateStickyOffsets = (columns: ColumnDefProps[]) => {
  let leftOffset = 0
  let rightOffset = 0

  return columns.map((col) => {
    if (!!col.stickyPosition && col.stickyPosition === 'left') {
      const offset = leftOffset
      leftOffset +=
        typeof col.minWidth === 'number'
          ? col.minWidth
          : typeof col.minWidth === 'string'
            ? parseInt(col.minWidth.replace('rem', '')) * 16
            : 160
      return { ...col, stickyOffset: offset }
    } else if (!!col.stickyPosition && col.stickyPosition === 'right') {
      const offset = rightOffset
      rightOffset +=
        typeof col.minWidth === 'number'
          ? col.minWidth
          : typeof col.minWidth === 'string'
            ? parseInt(col.minWidth.replace('rem', '')) * 16
            : 160
      return { ...col, stickyOffset: offset }
    }
    return col
  })
}
